function checkPasswordStrength(password) {
  let strength = 0;
  let msg = '';

  if (password.length < 12) {
    msg = "密码太短了，至少需要12个字符";
    return { strength, msg };
  }

  if (password.length >= 12) strength += 1;
  if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) strength += 1;
  if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) strength += 1;
  if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1;
  if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1;

  msg = ["密码太弱", "密码强度弱", "密码强度中等", "密码强度强", "密码强度非常强", "神秘的密码强度"][strength];
  return { strength, msg };

  // 返回密码强度  
  // switch (strength) {
  //   case 0:
  //     msg = "密码太弱";
  //     break;
  //   case 1:
  //     msg = "密码强度弱";
  //     break;
  //   case 2:
  //     msg = "密码强度中等";
  //     break;
  //   case 3:
  //     msg = "密码强度强";
  //     break;
  //   case 4:
  //     msg = "密码强度非常强";
  //     break;
  //   default:
  //     msg = "未知的密码强度";
  //     break;
  // }
  // return { strength, msg };
}

export default checkPasswordStrength